import React, { useState, useEffect } from "react";

import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AlertBox from './AlertBox'
import frm from './formAux.js'
import $ from 'jquery';


const AzureButton = () => {    

    // const hideFreshDeskWidget = () => {
    //     window.FreshworksWidget('hide');
    // }
    window.FreshworksWidget('hide'); //hide Freshworkwid gets mani
    
    return (
        <></>
    );
    // useEffect( function() {
    //     // hideFreshDeskWidget();
    //     $('#azurelogin').on('click', function(){
    //         window.azureLogin();
    //     });
    //     $('#azurelogout').on('click', function(){
    //         window.azureLogout();
    //     });
    //     if( !window.azureSSOEnabled ) {
    //         $('#azurelogin').remove()            
    //         $('#azurelogout').remove()            
    //     }
    // } );
    // return (
    //     <>
    //         <button id="azurelogin" className="btn mt-4"> <img className="" src="imgs/microsoft_logo.svg" /> Login with Single Sign-On</button>
    //         <button id="azurelogout" className="btn mt-4 hidden"> <img className="" src="imgs/microsoft_logo.svg" /> Logout Single Sign-On</button>
    //     </>
    // );
};


function Login(prop) {
    var mode = 0;
    useEffect(function (a) {
        $('.top_switch').remove();
        localStorage.clear();

        if( window.azureADFSEnabled ) {
            $('#ADFSButton').html('<button id="azurelogin" class="btn mt-4"> <img class="" src="imgs/microsoft_logo.svg"> Login with Single Sign-On</button>').find('button').on('click', () => {
                document.location.replace( window.azureADFSLogin )
            })
        }
        else {
            $('#ADFSButton').html('<button id="azurelogin" class="btn mt-4"> <img class="" src="imgs/microsoft_logo.svg"> Login with Single Sign-On</button>').find('button').on('click', () => {
                document.location.replace( window.servicePath + 'azure/signin' )
            })
        }

        // const queryParameters = new URLSearchParams(window.location.search)
        // var pp = queryParameters.get('next');
        var pp = window.getPageParams();
        // delete window.GlobalVars.postLogin;
        // alert( pp.next )
        if( pp.azureToken ) {
            window.GlobalVars.postLogin = null;
            return window.saveSession( () => {
                submit();
            });
        }
        if (pp.next) {  //if (pp.next)
            try {
                var pl = atob(pp.next);
                window.GlobalVars.postLogin = pl; 
            }
            catch (e) { console.error(e) }
            return window.saveSession( () => {
                document.location = '/?next=#Login';
            });
        }
        // if( document.location.href.indexOf('?next=#Login') == -1 ) {
        //     return document.location = '/?next=#Login';
        // }
        loginMode();
    })
    function submit(e)
    {
        if( e ) e.preventDefault();
        window.endSession();
        var pp = window.getPageParams();
        // alert(JSON.stringify({email:email,password:password}))

        if( pp.azureToken ) {
            var payload = {azureToken: pp.azureToken}
            localStorage.clear();
        }
        else {
            var email = $('#email').val().toLowerCase().trim();
            var password = $('#password').val().trim();
            if( email == '' )
            {
                console.log( 'email')
                window.alertBox('Please enter your E-mail', 'err');
                $('#email').focus();
                return false;
            }
            var payload = {email:email,password:password};
        }
        if( mode == 0 )
        {
            window.post( 'login', payload, function(res){
                var data = res.data;
                console.log( 'LOGIN', data )
                console.log('resx', res)
                // debugger;
                // alert( JSON.stringify(data))
                if( data.status )
                {
                    window.endSession();
                    var global = window.GlobalVars;
                    global.user = email || data.email;
                    global.userName = data.name;
                    global.userSession = data.sid;
                    global.userId = data._id;
                    global.userEmail = data.email;
                    global.userWorkerId = data.workerId;
                    global.userRoles = data.roles;
                    global.userMetadata = data.metadata;
                    global.azureUser = data.azure || false;
                    if( data.roles && data.roles.length == 1 )
                    {
                        global.userPriv = frm.arr2Bool( (data.priv || data.roles[0].priv) );
                        global.userCompany = data.company || data.roles[0].company;
                        global.userCurrentRole = data.currentRole;
                        global.usersupervisedProject = data.supervisedProject;
                    }
                    if( !data.roles || data.roles.length == 0 ) {
                        global.userPriv = {nlp_an: true};
                    }
                    global.sessionId = Math.random();
                    global.expireTime = Date.now()+1000*60*window.sessionDuration;
                    if( data.redefinePassword ) {
                        global.userRedefinePassword = data.redefinePassword;
                    }
                    window.saveSession();
                    window.alertBox( ' Signing in', 'loading')
                    setTimeout( function(){
                        // alert( data.gotoPage )
                        window.goPage( data.gotoPage || '' )
                    }, 1000 );
                }
                else
                {
                    window.alertBox( data.value, 'err' );
                }
            });
        }
        else {
            window.post( 'password_reset', {email:email}, function(res){
                if( res.data.status == 1 )
                {
                    loginMode();
                    window.alertBox('An email was sent to <b>'+email+'</b> with your temporary password. Please copy the password and login below.', 'ok')
                }
                else {
                    window.alertBox( res.data.value, 'err' );
                }
            })
        }

    }
    function loginMode()
    {
        mode = 0;
        window.alertOut();
        $('#password').show();
        $('h3').html('Login');
        $('#submitbtn').html('Login');
        $('#linkbtn').html('Forgot Password?').unbind('click').on('click', resetMode );
    }

    function resetMode()
    {
        mode = 1;
        window.alertOut();
        $('#password').hide();
        $('h3').html('Reset Password');
        $('#submitbtn').html('Reset Password');
        $('#linkbtn').html('Login with password').unbind('click').on('click', loginMode );
        $('#email').focus();
        setTimeout( function(){

        }, 100 )
    }

    if( window.deeplink ) return null;

    return (
        <div className="login_wrapper">
            <Container fluid="md" className="mp0">
                <Row>
                    <Col sm={3}></Col>
                    <Col sm={6}>
                         {/* <img className="login-logo" src="imgs/objectways-logo.png" />  */}
                        {/* <img className="login-logo" src="imgs/logo_T.svg" />  */}
                        {/* <img className="login-logo" src="imgs/new/logo2.png" />  */}
                        {/* <img className="login-logo" src="imgs/new/loginT.png" /> 14/4 mani */}
                        {/* <img className="login-logo" src="imgs/new/f3.svg" />  */}
                        <img className="login-logo" src="imgs/new/f8.png" /> 
                        <div className="login">

                                <Form method="GET" onSubmit={submit}>
                                    {/* <Form.Label><h3>Login</h3>Enter the details below</Form.Label> mani */}
                                    <Form.Label><h3>LOGIN</h3></Form.Label>  {/*15/12 mani */}
                                    <AlertBox />
                                    <FormControl type="e-mail" className="mb-2" id="email" placeholder="Email" />
                                    <FormControl type="password" id="password" placeholder="Password" />
                                    <Button id="submitbtn" variant="logoblue" type="submit" className="mt-2 mb-2">Login</Button>{/* modify varient=primary to pink 15/12 mani */}
                                    <a id="linkbtn" className="forgot-password-link" href="#Login">Forgot Password?</a>
                                </Form>
                                <AzureButton />
                                <div id="ADFSButton"></div>
                        </div>
                    </Col>
                    <Col sm={3}></Col>
                </Row>
            </Container>
        </div>
    )
}

export default Login
